import {Controller} from 'stimulus'

export  default class extends Controller {
    static  targets = ['notif']
    close(){
        this.notifTarget.classList.add('notif-hide')
    }
}